import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLDetailsElement> {
  preserveOpen(event: CustomEvent) {
    if (event.detail.attributeName === "open") {
      event.preventDefault();
    }
  }
}
